import { createTailwindMerge } from './create-tailwind-merge.mjs';
import { getDefaultConfig } from './default-config.mjs';

var twMerge = /*#__PURE__*/createTailwindMerge(getDefaultConfig);

export { twMerge };
//# sourceMappingURL=tailwind-merge.mjs.map
